import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, labelModes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${Services.sendings}.labels.title`),
        labelMode: labelModes.hidden,
        clearable: true,
        details: false,
        dense: true,
        disabled: this.disabled
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
function renderDialogBody(h) {
  return h(
    'div',
    {
      class: 'pt-2 px-2'
    },
    [
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${Services.sendings}.infos.title`),
            iconSVG: 'question-mark',
            color: Colors.info
          }
        }
      )
    ]
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        maxWidth: 550
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}
function renderInfoButton(h) {
  return h(
    button,
    {
      props: {
        iconSVG: 'question-mark',
        mode: buttonModes.flat,
        color: Colors.info,
        tooltip: this.getTranslate(`${Services.sendings}.tooltips.title`)
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__title`
    },
    [
      renderTitleField.call(this, h),
      renderInfoButton.call(this, h)
    ]
  )
}
